import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import bowser from 'LoginUI/vendor/bowser.min';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { withRouter } from 'quartz-routing/react-router';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module
import ImageUrl from '../../images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUPPORTED_BROWSERS = {
  chrome: '32',
  chromium: '32',
  firefox: '28',
  msedge: '12',
  msie: '11',
  safari: '6.1'
};
const HUBSPOT_ANDROID_UA = /^HubSpotAndroid\//;
const HUBSPOT_IOS_UA = /^HubSpotiOS\//;
const ZOOM_WEB_KIT_UA = /ZoomWebKit\//;
class BrowserVersionWrapper extends Component {
  constructor(props) {
    super(props);
    this.renderOutdatedBrowser = (browserName, browserVersion) => {
      return /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignSelf: "center",
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(Image, {
            src: ImageUrl.unsupportedBrowser,
            marginBlock: "300",
            blockSize: "100px"
          })
        }), /*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.header"
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.instructions",
            options: {
              browserName,
              browserVersion
            }
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "400"
        }), /*#__PURE__*/_jsx(Button, {
          href: "https://knowledge.hubspot.com/articles/KCS_Article/Resources/Which-browsers-are-supported-by-HubSpot",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.outdatedBrowser.button"
          })
        })]
      });
    };
    this.renderUnrecognizedBrowser = browserName => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Alert, {
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.unsupported.unrecognizedBrowser",
            options: {
              browserName
            }
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "400"
        }), this.props.children]
      });
    };
    const {
      search
    } = props.location;
    const query = parseQuery(search.substr(1));
    const {
      isOutlook
    } = query;
    const {
      name: _browserName,
      version: _browserVersion
    } = bowser;
    const isOutdatedBrowser = bowser.isUnsupportedBrowser(SUPPORTED_BROWSERS, false);
    const isUnknownBrowser = bowser.isUnsupportedBrowser(SUPPORTED_BROWSERS, true);
    const userAgent = typeof window.navigator !== 'undefined' ? window.navigator.userAgent || '' : '';
    const isHubSpotMobile = HUBSPOT_ANDROID_UA.test(userAgent) || HUBSPOT_IOS_UA.test(userAgent);
    const isZoom = ZOOM_WEB_KIT_UA.test(userAgent);
    this.state = {
      browserName: _browserName,
      browserVersion: _browserVersion,
      isHubSpotMobile,
      isOutdatedBrowser,
      isOutlook,
      isUnknownBrowser,
      isZoom
    };
  }
  render() {
    const {
      browserName,
      browserVersion,
      isHubSpotMobile,
      isOutdatedBrowser,
      isOutlook,
      isUnknownBrowser,
      isZoom
    } = this.state;
    if (!isOutlook && !isHubSpotMobile && !isZoom) {
      if (isOutdatedBrowser) {
        return this.renderOutdatedBrowser(browserName, browserVersion);
      } else if (isUnknownBrowser) {
        return this.renderUnrecognizedBrowser(browserName);
      }
    }
    return this.props.children;
  }
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof BrowserVersionWrapper' is... Remove this comment to see the full error message
export default withRouter(BrowserVersionWrapper);